import './ContactApp.css'
import FooterBar from '../FooterBar/FooterBar';
import React, { useState, useEffect } from 'react';
import ContactAppHeader from './ContactAppHeader/ContactAppHeader';
import ContactAppBody from './ContactAppBody/ContactAppBody';


function ContactApp({stateName,LinkBarProps,picture,fullName,IoIosDocument, getContactCard}) {
  // Info window cycling state
  const infoOptions = ['Home', 'Messaging', 'Pictures', 'Resume'];
  const [currentInfoIndex, setCurrentInfoIndex] = useState(0);
  const [infoVisible, setInfoVisible] = useState(true);

  useEffect(() => {
    setInfoVisible(true);
    const timer = setTimeout(() => {
      setInfoVisible(false);
      setTimeout(() => {
        setCurrentInfoIndex((prev) => (prev + 1) % infoOptions.length);
        setInfoVisible(true);
      }, 400); // fade out before next
    }, 2200); // show each for 2.2s
    return () => clearTimeout(timer);
  }, [currentInfoIndex]);

  return (
    <div className='Contact-App'>
        <div className='CA-Primary'>
          <div className='CA-P-Profile'>
            <div className='CA-PP-Inner'>
              <ContactAppHeader picture={picture} fullName={fullName}/>
              <ContactAppBody IoIosDocument getContactCard={getContactCard}/>
            </div>
          </div>
        </div>
        {/* Animated, shifting info window */}
        {infoVisible && (
          <div
            className='info-window-animated info-window-single'
            style={{ left: `${20 + currentInfoIndex * 20}%` }}
          >
            <span className='info-option'>{infoOptions[currentInfoIndex]}</span>
          </div>
        )}
        <FooterBar linkBarList={LinkBarProps.inputBarLinks} handleLinkClick={LinkBarProps.changeStateTo} exclude={stateName}/>
    </div>
  )
}

export default ContactApp